import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import LayersIcon from "@mui/icons-material/Layers";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Link } from "react-router-dom";
import axios from "axios";
import { url } from "../../baseUrl";

// var menuItems = [];

// export const mainListItems = async () => {
//   try {
//     await axios
//       .get(`${url}/menu`)
//       .then((data) => {
//         console.log("response", data.data.data.data);
//         data.data.data.data.map((item) => {
//           menuItems.push(item);
//         });

//         console.log("menuItems");
//       })
//       .then(() => {
//         return (
//           <React.Fragment>
//             {menuItems.map((mn) => (
//               <Link
//                 to={mn.menuUrl}
//                 style={{ textDecoration: "none", color: "black" }}
//               >
//                 <ListItemButton>
//                   <ListItemIcon>
//                     <DashboardIcon />
//                   </ListItemIcon>
//                   <ListItemText primary={mn.menuName} />
//                 </ListItemButton>
//               </Link>
//             ))}
//           </React.Fragment>
//         );
//       });
//   } catch (error) {
//     console.log("error", error.message);
//   }
// };
// console.log("main Meni items", Promise.all([mainListItems]));
// const menuItems = [
//   {
//     menuId: 1,
//     menuName: "Dashboard",
//     menuUrl: "/",
//   },
//   {
//     menuId: 2,
//     menuName: "MainLeads",
//     menuUrl: "mainleadslist",
//   },
//   {
//     menuId: 3,
//     menuName: "Create Leads",
//     menuUrl: "mainleadsform",
//   },
//   {
//     menuId: 4,
//     menuName: "UserSetup",
//     menuUrl: "usersetup",
//   },
//   {
//     menuId: 5,
//     accessType: [],
//     menuName: "Add User",
//     menuUrl: "adduser",
//   },
// ];

// export const mainListItems = (

//     { () => {
//        axios.get(`${url}/menu`).then((data) => {
//         console.log("response", data.data.data.data);
//         data.data.data.data.map((mn) => {
//         });
//       });
//     }}
// );

// export const secondaryListItems = (
//   <React.Fragment>
  
//     <ListItemButton>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText primary="Current month" />
//     </ListItemButton>
//     <ListItemButton>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText primary="Last quarter" />
//     </ListItemButton>

//     <ListItemButton>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText primary="Year-end sale" />
//     </ListItemButton>
//   </React.Fragment>
// );
